import { fill } from './fill.js'
import { DemoReportCardProvincialGr78202309 as Page } from './Page.jsx'
import templateUrl from './template.pdf'

export default {
  key: 'pvrc7to8_2023_09',
  label: 'Provincial Report - Gr. 7–8',
  templateUrl,
  fill,
  Page,
}
